export default __webpack_public_path__ + "static/media/homeBannerBg.56182941.png";